import React from 'react';
import { Scissors, Shirt, ToyBrick, Bed, Sparkles, CircleDot } from 'lucide-react';
import { petshopProducts } from '../data/mock';

const iconMap = {
  'scissors': Scissors,
  'shirt': Shirt,
  'toy-brick': ToyBrick,
  'bed': Bed,
  'sparkles': Sparkles,
  'circle-dot': CircleDot
};

const Petshop = () => {
  const images = [
    'https://images.unsplash.com/photo-1535294435445-d7249524ef2e?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1589924749359-9697080c3577?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1610714520720-ba92ae46e0e2?crop=entropy&cs=srgb&fm=jpg&q=85'
  ];

  return (
    <section id="petshop" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block">
            <span className="text-rose-600 font-semibold text-sm uppercase tracking-wider">Petshop</span>
            <div className="h-1 w-20 bg-rose-500 mt-2 rounded-full mx-auto"></div>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Todo para tu Mascota
          </h2>
          
          <p className="text-lg text-gray-600">
            Encuentra los mejores productos y accesorios para el cuidado, diversión y confort de tu compañero.
          </p>
        </div>

        {/* Images Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {images.map((img, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-64"
            >
              <img
                src={img}
                alt={`Pet products ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {petshopProducts.map((product) => {
            const Icon = iconMap[product.icon];
            return (
              <div
                key={product.id}
                className="group bg-gradient-to-br from-rose-50 to-white rounded-xl p-6 border border-rose-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-rose-500 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {product.category}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {product.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Visit Us CTA */}
        <div className="mt-16 bg-gradient-to-r from-rose-500 to-pink-500 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Vení a Nuestra Tienda
          </h3>
          <p className="text-lg md:text-xl mb-6 text-rose-50 max-w-2xl mx-auto">
            Encontrá todos estos productos y más en nuestro petshop. ¡Te esperamos!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white text-rose-600 font-semibold rounded-xl hover:bg-rose-50 transition-colors duration-200 shadow-lg"
            >
              Ver Ubicación
            </button>
            <button
              onClick={() => window.open('https://wa.me/5491162573889?text=Hola! Quisiera consultar sobre productos del petshop.', '_blank')}
              className="px-8 py-4 bg-rose-700 text-white font-semibold rounded-xl hover:bg-rose-800 transition-colors duration-200 shadow-lg"
            >
              Consultar por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Petshop;